import { useHirerAuth } from '@seek/hirer-auth-react';
import {
  Text,
  Actions,
  Box,
  Stack,
  Heading,
  ContentBlock,
} from 'braid-design-system';
import React from 'react';

import { ButtonLink, TextLink } from 'src/components';
import { TRACKING_CODES } from 'src/shared/constant';
import { useLocalized } from 'src/shared/hooks';
import { REGISTER, SIGN_IN } from 'src/shared/links';

const FooterBlock = () => {
  const { authenticated, loading } = useHirerAuth();
  const titleText = useLocalized({
    NZ: "New Zealand's most visited employment site",
    AU: "Australia's most visited employment site with over 2.5 times the visits of our nearest competitor.",
  });
  return authenticated ? null : (
    <ContentBlock>
      <Box
        paddingBottom={['gutter', 'large', 'xxlarge']}
        paddingX={['gutter', 'gutter']}
        alignItems="center"
      >
        <Stack space="xlarge" align="center">
          <Box alignItems="center" style={{ maxWidth: '618px' }}>
            <Heading level="2" align="center">
              {titleText}
            </Heading>
          </Box>
          <Stack space="large" align="center">
            <Actions>
              <ButtonLink
                tone="formAccent"
                variant="ghost"
                tracking="register_link_clicked"
                href={REGISTER}
                loading={loading}
              >
                Register for free
              </ButtonLink>
            </Actions>
            <Text align="center">
              Already have an account?{' '}
              <TextLink
                href={SIGN_IN}
                tracking={TRACKING_CODES.sign_in_link_clicked}
              >
                Sign in
              </TextLink>
            </Text>
          </Stack>
        </Stack>
      </Box>
    </ContentBlock>
  );
};

export default FooterBlock;
